import { Component, Input, OnInit } from '@angular/core';
import { MetricCard } from '../../models/metric-cards.model';
import { MetricCardService } from '../../services/metric-card/metric-card.service';
import { NgClass } from '@angular/common';
import { DecodeHtmlStringPipe } from '../../pipes/decode-htm-string.pipe';
import { DecodeHtmlString } from '../../../../../core/src/app/feature-modules/deice/pipes/html-decode.pipe';

@Component({
    selector: 'emt-metric-card',
    templateUrl: './metric-card.component.html',
    styleUrls: ['./metric-card.component.scss'],
    imports: [
        NgClass,
        DecodeHtmlStringPipe,
        DecodeHtmlString,
    ],
})
export class MetricCardComponent implements OnInit {
  @Input() metricCard: MetricCard;
  @Input() isLastChild: boolean;
  @Input() isCondensedMode: boolean;

  public isNotLastChild: boolean;

  private selectedCardId: string;

  constructor(private metricCardService: MetricCardService) {}

  ngOnInit() {
    this.isNotLastChild = !this.isLastChild;
    this.metricCardService.getSelectedCard().subscribe(id => {
      this.selectedCardId = id;
    });
  }

  public handleCardClick() {
    if (!this.metricCard.clickable) {
      return;
    }
    this.metricCardService.setSelectedCard(this.selectedCardId !== this.metricCard.id ? this.metricCard.id : undefined);
    this.metricCardService.setSelectedReportType(this.metricCard.reportType);
  }
}
